import clsx, { type ClassValue } from "clsx";

/** Kurzschreibweise für bedingte Klassenlisten. */
export function cn(...values: ClassValue[]): string {
  return clsx(values);
}
